/**
 * Merges the store and details objects and adds or overrides the zipCode property.
 *
 * @typedef {Object} MergedData
 * @property {string} [zipCode] - The zip code (optional).
 * @property {string | number} [storeId] - The store id (optional).
 * @property {import('../types').Store} [Store] - Store (optional).
 * @property {import('../types').Details} [Details] - Details from the store (optional).
 *
 * @param {{
 *  availabilityData: import('../types').bopsAvailabilityXapiResponce
 *  storeId: string
 * }} param0
 *
 * @returns {MergedData}
 */
export const pickupStoreParser = ({ availabilityData, storeId }) => {
  const isAvailabilityDataFilled = Object.keys(availabilityData).length > 0 && !!availabilityData.store;

  if (!isAvailabilityDataFilled) return {};

  const { store } = availabilityData;
  const { details = {}, address = { zipCode: '' }, identifier } = store;

  return {
    ...store,
    ...details,
    storeId: identifier?.storeLocation || storeId,
    zipCode: address?.zipCode || '',
  };
};

export default pickupStoreParser;
